import BaseService from './BaseService';

class EvaluationService extends BaseService {
  constructor() {
    super('/evaluations');
  }
  /**
   * Get all evaluations
   */
  async getEvaluations(params = {}, options = {}) {
    return this.get('', params, options);
  }

  /**
   * Get a specific evaluation
   */
  async getEvaluation(id) {
    this.validateRequired({ id }, ['id']);
    return this.get(`/${id}`);
  }

  /**
   * Create a new evaluation
   */
  async createEvaluation(data) {
    this.validateRequired(data, ['name', 'type']);
    return this.post('', data);
  }

  /**
   * Update an evaluation
   */
  async updateEvaluation(id, data) {
    this.validateRequired({ id }, ['id']);
    return this.put(`/${id}`, data);
  }

  /**
   * Delete an evaluation
   */
  async deleteEvaluation(id) {
    this.validateRequired({ id }, ['id']);
    return this.delete(`/${id}`);
  }

  /**
   * Execute an evaluation
   */
  async executeEvaluation(id, options = {}) {
    this.validateRequired({ id }, ['id']);
    return this.post(`/${id}/execute`, options);
  }

  /**
   * Get evaluation results
   */
  async getEvaluationResults(id, params = {}) {
    this.validateRequired({ id }, ['id']);
    return this.get(`/${id}/results`, params);
  }

  /**
   * Get evaluation audit logs
   */
  async getEvaluationLogs(id, params = {}) {
    this.validateRequired({ id }, ['id']);
    return this.get(`/${id}/logs`, params);
  }

  /**
   * Get all evaluation runs
   */
  async getEvaluationRuns(params = {}, options = {}) {
    console.log('EvaluationService: getEvaluationRuns called with params:', params);
    console.log('EvaluationService: baseEndpoint:', this.baseEndpoint);
    console.log('EvaluationService: full URL will be:', this.baseEndpoint + '/runs');
    try {
      const result = await this.get('/runs', params, options);
      console.log('EvaluationService: getEvaluationRuns result:', result);
      return result;
    } catch (error) {
      console.error('EvaluationService: getEvaluationRuns error:', error);
      console.error('EvaluationService: error response:', error.response);
      console.error('EvaluationService: error status:', error.response?.status);
      console.error('EvaluationService: error data:', error.response?.data);
      throw error;
    }
  }

  /**
   * Get a specific evaluation run
   */
  async getEvaluationRun(runId) {
    this.validateRequired({ runId }, ['runId']);
    return this.get(`/runs/${runId}`);
  }

  /**
   * Schedule evaluation from a run
   */
  async scheduleFromRun(runId, scheduleData) {
    this.validateRequired({ runId }, ['runId']);
    return this.post(`/runs/${runId}/schedule`, scheduleData);
  }

  /**
   * Send run results via email
   */
  async sendRunEmail(runId, emailData) {
    this.validateRequired({ runId }, ['runId']);
    return this.post(`/runs/${runId}/send-email`, emailData);
  }

  /**
   * Send run results via webhook
   */
  async sendRunWebhook(runId, webhookData) {
    this.validateRequired({ runId }, ['runId']);
    return this.post(`/runs/${runId}/send-webhook`, webhookData);
  }

  /**
   * Cancel an evaluation run
   */
  async cancelRun(runId) {
    this.validateRequired({ runId }, ['runId']);
    return this.delete(`/runs/${runId}`);
  }

  /**
   * Get run progress
   */
  async getRunProgress(runId) {
    this.validateRequired({ runId }, ['runId']);
    return this.get(`/runs/${runId}/progress`);
  }

  /**
   * Get all scheduled evaluations
   */
  async getScheduledEvaluations(params = {}, options = {}) {
    return this.get('/schedules', params, options);
  }

  /**
   * Schedule an evaluation
   */
  async scheduleEvaluation(evaluationId, scheduleData) {
    this.validateRequired({ evaluationId }, ['evaluationId']);
    const response = await this.post(`/${evaluationId}/schedule`, scheduleData);

    // Clear the schedules cache only if the request was successful
    if (response.success !== false) {
      this.clearCache('/schedules');
    }

    return response;
  }

  /**
   * Enable evaluation schedule
   */
  async enableSchedule(evaluationId) {
    this.validateRequired({ evaluationId }, ['evaluationId']);
    return this.post(`/${evaluationId}/schedule/enable`, {});
  }

  /**
   * Disable evaluation schedule
   */
  async disableSchedule(evaluationId) {
    this.validateRequired({ evaluationId }, ['evaluationId']);
    return this.post(`/${evaluationId}/schedule/disable`, {});
  }

}

const evaluationService = new EvaluationService();
export default evaluationService;
